import { render, staticRenderFns } from "./vehicleSpecifiedCostList.vue?vue&type=template&id=f062b6f0"
import script from "./vehicleSpecifiedCostList.vue?vue&type=script&lang=js"
export * from "./vehicleSpecifiedCostList.vue?vue&type=script&lang=js"
import style0 from "./vehicleSpecifiedCostList.vue?vue&type=style&index=0&id=f062b6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports